if (!customElements.get('side-nav')) {
  // Sections in a JSON template render as
  // shopify-section-template--<theme_id>__<key>, and the theme id changes with
  // every copy of the theme, so "shopify-section-<key>" never matches on its
  // own. Try that plain form first anyway (section groups and statically
  // rendered sections do use it), then fall back to matching the key as the
  // suffix, then to a hand-written id on the section itself.
  const resolveTarget = (domId) => {
    if (!domId) return null;

    const direct = document.getElementById(domId);
    if (direct) return direct;

    const key = domId.replace(/^shopify-section-/, '');
    const escaped = window.CSS && CSS.escape ? CSS.escape(key) : key.replace(/"/g, '\\"');

    return (
      document.querySelector(`[id^="shopify-section-"][id$="__${escaped}"]`) ||
      document.getElementById(key)
    );
  };

  class SideNav extends HTMLElement {
    constructor() {
      super();

      this.links = Array.from(this.querySelectorAll('.side-nav__link'));
      this.entries = this.links
        .map((link) => {
          const target = resolveTarget(link.dataset.target);
          return target ? { link, target } : null;
        })
        .filter(Boolean);

      this.links.forEach((link) => {
        link.addEventListener('click', this.onLinkClick.bind(this));
      });

      if (this.entries.length === 0) return;

      this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
        rootMargin: '-40% 0px -40% 0px',
        threshold: 0,
      });

      this.entries.forEach(({ target }) => this.observer.observe(target));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    onIntersection(observedEntries) {
      observedEntries.forEach((observedEntry) => {
        const match = this.entries.find(({ target }) => target === observedEntry.target);
        if (!match) return;
        match.link.classList.toggle('is-active', observedEntry.isIntersecting);
      });
    }

    onLinkClick(event) {
      const link = event.currentTarget;
      const target = resolveTarget(link.dataset.target);
      if (!target) return;

      event.preventDefault();

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start',
      });
    }
  }

  customElements.define('side-nav', SideNav);
}
